import styled from 'styled-components';

import Img from '~/components/Img';
import { colors, layout } from '~/utils/css-mixins';
import media from '~/utils/media';
import { imagePropType } from '~/utils/prop-types';

const Root = styled.div`
  margin-bottom: 1.5rem;
  max-width: 810px;

  ${media.desktop`
    margin-bottom: 2rem;
  `}
`;

const ImgWrapper = styled.div`
  margin-left: ${-1 * layout.oneColumn.pageGutter}px;
  margin-right: ${-1 * layout.oneColumn.pageGutter}px;

  ${media.tablet`
    margin: 0;
  `}
`;

const StyledImg = styled(Img)`
  display: block;
  max-width: 100%;
`;

const ImgCaption = styled.div`
  margin-top: 0.5rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5385;

  ${media.tablet`
    font-size: 13px;
  `}
`;

const ImgCaptionText = styled.span`
  color: ${props => props.color};
`;

const getAltText = image =>
  image.caption != null && image.caption.length > 0 ? image.caption : '';

const getCaption = image => {
  if (image == null) {
    return null;
  } else {
    const caption = [
      image.caption,
      image.photographer != null && image.photographer.length > 0
        ? `Foto: ${image.photographer}`
        : '',
    ].filter(Boolean);
    if (caption.length > 0) {
      return caption.map(c => (
        <ImgCaptionText
          color={c === image.caption ? colors.bodyText : colors.textmeta}
          key={c}
        >
          {c}{' '}
        </ImgCaptionText>
      ));
    } else {
      return null;
    }
  }
};

const Image = ({ image }) => {
  if (image == null) {
    return null;
  }
  const caption = getCaption(image);
  return (
    <Root>
      <ImgWrapper>
        <StyledImg image={image} width={810} alt={getAltText(image)} />
      </ImgWrapper>
      {caption && <ImgCaption>{caption}</ImgCaption>}
    </Root>
  );
};

Image.propTypes = {
  image: imagePropType,
};

export default Image;
